// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"674":"cdc28071","822":"f5a20ddd"}[chunkId] + ".chunk.js";
};